@if (isVisible()) {
<div class="flex h-full min-h-0 flex-col overflow-hidden">

  <div class="shrink-0 border-b border-gray-200 bg-muted/50 px-3 py-3 dark:border-white/10">
    <div class="flex flex-wrap items-center justify-between gap-x-3 gap-y-1 sm:flex-nowrap">
      <div class="flex min-w-0 items-center gap-x-2">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" class="size-5 shrink-0 text-accent" aria-hidden="true">
          <path d="M4.9 16.1C1 12.2 1 5.8 4.9 1.9" />
          <path d="M7.8 4.7a6.14 6.14 0 0 0-.8 7.5" />
          <circle cx="12" cy="9" r="2" />
          <path d="M16.2 4.8c2 2 2.26 5.11.8 7.47" />
          <path d="M19.1 1.9a9.96 9.96 0 0 1 0 14.2" />
          <path d="M9.5 18h5l3 4h-11z" />
        </svg>
        <div class="min-w-0">
          <h3 class="truncate text-sm font-semibold text-primary">Where this creator has posted</h3>
          <p class="mt-0.5 hidden truncate text-xs text-secondary sm:block">
            @if (hasCommittedHire()) {
            Committed to {{ creatorFirstName() }}
            } @else {
            Nothing committed yet
            }
          </p>
        </div>
      </div>
      @if (committedTotal(); as total) {
      <div class="flex flex-col items-end text-right">
        <p class="m-0 text-sm font-semibold tabular-nums text-primary">{{ total | currency: currencyCode() }}</p>
        @if (committedVat() > 0 && committedNet() !== null) {
        <p class="m-0 mt-0.5 text-xs tabular-nums text-secondary">
          {{ committedNet() | currency: currencyCode() }} + {{ committedVat() | currency: currencyCode() }} VAT
        </p>
        }
      </div>
      } @else {
      <p class="m-0 text-sm text-secondary">—</p>
      }
    </div>
  </div>

  <div class="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto p-2 scrollbar-transparent">
    @for (row of rows(); track row.socialChannel) {
    <div [class]="cellSurfaceClass(row)">
      <div class="flex items-start gap-x-2">
        <mbt-cross-platform-tile [socialChannel]="row.socialChannel" [state]="row.state" [label]="row.label"
          [postStatus]="row.post?.status ?? null" [interactive]="false"></mbt-cross-platform-tile>

        <div class="min-w-0 flex-1">
          <div class="flex items-center justify-between gap-x-2">
            <p class="m-0 truncate text-xs font-semibold text-primary">{{ row.label }}</p>
            <span [class]="row.isPrimary ? 'pill pill-dark shrink-0' : 'pill pill-purple shrink-0'">{{ row.roleLabel }}</span>
          </div>
          <p class="m-0 mt-0.5 truncate text-xxs text-secondary" [title]="row.detail">{{ row.detail }}</p>
        </div>
      </div>

      @if (row.post?.fullUrl) {
      <div class="flex items-center">
        <a [href]="row.post!.fullUrl" target="_blank" rel="noopener noreferrer"
          class="inline-flex items-center gap-x-1 rounded-sm text-xs font-medium text-accent hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          [attr.aria-label]="'View ' + row.label + ' post'">
          View post
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="size-3" aria-hidden="true">
            <path d="M15 3h6v6" />
            <path d="M10 14 21 3" />
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
          </svg>
        </a>
      </div>
      }

      <div class="flex flex-wrap items-center justify-between gap-x-2 gap-y-1">
        <span [class]="row.statusPill.className" [title]="row.statusPill.label">{{ row.statusPill.label }}</span>
        <div class="flex flex-wrap items-center justify-end gap-x-1.5 gap-y-1">
          @if (row.price === null) {
          <p class="m-0 text-xs text-secondary" [title]="unpricedTitle(row)">—</p>
          } @else {
          <p class="m-0 text-xs font-semibold tabular-nums text-primary">{{ row.price | currency: currencyCode() }}</p>
          }
          <p class="m-0 text-xs text-secondary">
            @if (row.price === null && (row.isPrimary || row.state === 'assigned' || row.state === 'posted')) {
            @if (row.isPrimary) { not committed yet } @else { no follower data }
            } @else if (row.priceIsCommitted) {
            @switch (row.state) {
            @case ('posted') { paid }
            @default { committed }
            }
            } @else {
            @switch (row.state) {
            @case ('excluded') { not hired }
            @case ('none') { unavailable }
            @case ('locked') { not offered }
            @default { estimated }
            }
            }
          </p>
          @if (row.canCancel) {
          <button type="button" (click)="onCancel(row)" [disabled]="cancelling() !== null"
            class="btn-shout btn-shout-xs btn-shout-alert shrink-0"
            [attr.aria-label]="'Cancel the ' + row.label + ' cross-post'">
            {{ cancelling() === row.socialChannel ? 'Cancelling…' : 'Cancel' }}
          </button>
          }
        </div>
      </div>
    </div>
    }
  </div>
</div>
}
